module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"copyLink":"Скопировать ссылку"}}')
  delete Component.options._Ctor
}
